import { subscribeNamedNotify } from "../../@helpers/js/observer.js";

export default function ToggleButtonListener(element, {
        triggerName = '',
        className = 't-hidden',
        reverse = false
    } = {}) {

    subscribeNamedNotify('toggle-button-trigger', {name: triggerName, fn: ({checked = false}) => {
        className ??= 't-hidden';
        if ((checked && !reverse) || (!checked && reverse)) {
            if (className === 't-hidden') {
                element.classList.remove(className);
            } else {
                element.classList.add(className);
            }
        } else {
            if (className === 't-hidden') {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        }
    }})
};